import { render } from "./ViewTenantReview.vue?vue&type=template&id=387e8a28&scoped=true&ts=true"
import script from "./ViewTenantReview.vue?vue&type=script&lang=ts"
export * from "./ViewTenantReview.vue?vue&type=script&lang=ts"

import "./ViewTenantReview.vue?vue&type=style&index=0&id=387e8a28&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387e8a28"]])

export default __exports__